module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/american_express@2x-4855fd28f2c2960a722e9a61060c51a0.png";